export default [
  {
    image: 'http://lorempixel.com/400/400/food',
    canOrder: 1,
    id: 2922,
    name: 'Drinks',
  },
  {
    image: 'http://lorempixel.com/401/401/food',
    canOrder: 1,
    id: 2923,
    name: 'Food',
  },
  {
    image: 'http://lorempixel.com/402/402/food',
    canOrder: 1,
    id: 2924,
    name: 'Other',
  },
  {
    image: 'http://lorempixel.com/403/403/food',
    canOrder: 1,
    id: 2925,
    name: 'Vegan',
  },
  {
    image: 'http://lorempixel.com/404/404/food',
    canOrder: 1,
    id: 2926,
    name: 'Junk food',
  },
  {
    image: 'http://lorempixel.com/405/405/food',
    canOrder: 1,
    id: 2927,
    name: 'Chinese',
  },
];
